import { WindowHelper } from '../WindowHelper';

export default class Zoom {
    initWhenLoaded() {
        /*for (let i = 0; i < this.allZoomImages.length; i++) {
            this.allZoomImages[i].addEventListener('load', () => {
                this.allZoomContainers[i].style.height = `${parseInt(this.allZoomImages[i].clientHeight)}px`;
                this.allZoomContainers[i].style.width = `${parseInt(this.allZoomImages[i].clientWidth)}px`;
            }, true);
        }*/
    }

    init() {
        this.allZoomContainers = document.querySelectorAll('.zoom');
        this.allZoomImages = document.querySelectorAll('.zoom img');
        this.initWhenLoaded();
    }

    constructor() {
        if (WindowHelper.isElementThere('.zoom')) this.init();
    }
}
